import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { AddressFieldModule } from '../../address-field'
import { PaymentCardFormModule } from '../../payment-card-form'
import { PatientCreditCardDialogComponent } from './dialog/patient-credit-card-dialog.component'
import { PatientCreditCardComponent } from './patient-credit-card.component'

@NgModule({
  imports: [
    AddressFieldModule,
    PaymentCardFormModule,
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    PipesModule,
    TranslateModule,
  ],
  declarations: [PatientCreditCardComponent, PatientCreditCardDialogComponent],
  exports: [PatientCreditCardComponent, PatientCreditCardDialogComponent],
})
export class PatientCreditCardModule {}
